import styled from 'styled-components/macro';
// import { motion } from 'framer-motion';
// import theme from '../../styles/GlobalTheme/schema.json';
import { defaultStyle } from '../../styles/GlobalTheme/GlobalStyles';
import px2vw from '../../utils/px2vw';

// const media = {
//     xs: (styles) => `
//         @media only screen and (max-width: 480px) {
//             ${styles}
//         }
//     `
// }

const padding = 0
const margin = 0

export const Content = styled.p`
    font-family: ${props => props.theme.fontFamily};
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 36px;
    color: #0A2540;

    @media only screen and (max-width: 768px) {
        font-size: 20px;
    }

    @media only screen and (max-width: 425px) {
        font-size: 14px;
        line-height: 28px;
    }
`;
export const Items = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media only screen and (max-width: 425px) {
        flex-direction: column;
    }
`;

export const Item = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 30px;
    align-items: center;

    @media only screen and (max-width: 425px) {
        margin-top: 10px;
        flex-direction: row;
        align-items: center;
    }
`;

export const ItemIcon = styled.img`
    width: 72px;
    height: 72px;
    margin-right: ${px2vw(30)};
    @media only screen and (max-width: 425px) {
        /* height: 50px; */
        /* width: 50px; */
        img {
            height: 60px;
        }
    }

    @media only screen and (max-width: 768px) {
        height: 60px;
        width: 60px;
    }
`;

export const ItemText = styled.p`
    font-family: ${props => props.theme.fontFamily};
    font-style: normal;
    font-weight: bold;
    color: ${props => props.fontColor || 'black'};
    font-size: 28px;
    line-height: 44px;
    max-width: ${px2vw(752)};
    align-self: center;
    /* margin-top: 25.35px; */

    @media only screen and (max-width: 768px) {
        font-size: 20px;
        line-height: 25px;
        margin-top: 5px;
    }

    @media only screen and (max-width: 425px) {
        margin-top: 5px;
        margin: auto;
        /* margin-left: 10px; */
        max-width: 100%;
        font-size: 16px;
        line-height: 18px;
    }

    @media only screen and (max-width: 375px) {
        font-size: 12x;
    }

    @media only screen and (max-width: 320px) {
        font-size: 12x;
    }
`;